module.exports = __webpack_public_path__ + "img/autospin_btn.6de90171.png";